import { eventApi } from './api';

const FaqService = (() => {
	function getArticlesMostAccessed() {
		return eventApi.get(`/public/faq/article/most-accessed`);
	}

	function getSections(params = {}, payload = {}) {
		return eventApi.post(`/public/faq/section/filter`, payload, { params });
	}

	function getSection(sectionId) {
		return eventApi.get(`/public/faq/section/${sectionId}`);
	}

	function getSectionArticles(sectionId, params = {}, payload = {}) {
		return eventApi.post(`/public/faq/article/section/${sectionId}`, payload, { params });
	}

	function getArticles(params = {}, payload = {}) {
		return eventApi.post(`/public/faq/article/filter`, payload, { params });
	}

	function getArticleContent(url) {
		return eventApi.get(`/public/faq/article/url/${url}`);
	}

	function articleUpvote(articleId) {
		return eventApi.get(`/public/faq/article/${articleId}/like`);
	}

	function articleDownvote(articleId) {
		return eventApi.get(`/public/faq/article/${articleId}/unlike`);
	}

	function sendDoubt(payload) {
		return eventApi.post(`/public/faq/doubt`, payload);
	}

	return {
		getArticlesMostAccessed: getArticlesMostAccessed,

        getSections: getSections,
        getSection: getSection,
        getSectionArticles: getSectionArticles,

        getArticles: getArticles,
        getArticleContent: getArticleContent,
        articleUpvote: articleUpvote,
        articleDownvote: articleDownvote,

        sendDoubt: sendDoubt,
	}
})();

export default FaqService;
